import _definePage_default_0 from '/home/vsts/work/1/s/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in).vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/admin.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/admin/scripts.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/calls.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/calls/call-history.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/calls/live-call.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/customers.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/customers/[id]/(profile).vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/dashboard.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/documents.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/feedback.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/help.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/api-keys.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/crm.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/hooks.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/scripts.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/services.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/leaderboard.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/lessons/index.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/index.vue?definePage&vue&lang.tsx'
import _definePage_default_23 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/_template.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/rules.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/scorecard-templates.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/multiscore.vue?definePage&vue&lang.tsx'
import _definePage_default_27 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/my-account.vue?definePage&vue&lang.tsx'
import _definePage_default_28 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/rules.vue?definePage&vue&lang.tsx'
import _definePage_default_29 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecard-templates/index.vue?definePage&vue&lang.tsx'
import _definePage_default_30 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecard-templates/[id]/index.vue?definePage&vue&lang.tsx'
import _definePage_default_31 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecard-templates/new.vue?definePage&vue&lang.tsx'
import _definePage_default_32 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecards/index.vue?definePage&vue&lang.tsx'
import _definePage_default_33 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecards/[id]/result.vue?definePage&vue&lang.tsx'
import _definePage_default_34 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecards/scorecard.vue?definePage&vue&lang.tsx'
import _definePage_default_35 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scripts/index.vue?definePage&vue&lang.tsx'
import _definePage_default_36 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/tasks.vue?definePage&vue&lang.tsx'
import _definePage_default_37 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/teams.vue?definePage&vue&lang.tsx'
import _definePage_default_38 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/training.vue?definePage&vue&lang.tsx'
import _definePage_default_39 from '/home/vsts/work/1/s/src/pages/(app)/(logged-in)/users.vue?definePage&vue&lang.tsx'
import _definePage_default_40 from '/home/vsts/work/1/s/src/pages/(app)/(logged-out).vue?definePage&vue&lang.tsx'
import _definePage_default_41 from '/home/vsts/work/1/s/src/pages/(app)/(logged-out)/auth/callback.vue?definePage&vue&lang.tsx'
import _definePage_default_42 from '/home/vsts/work/1/s/src/pages/(app)/(logged-out)/auth/logout.vue?definePage&vue&lang.tsx'
import _definePage_default_43 from '/home/vsts/work/1/s/src/pages/select.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/',
      component: () => import('/home/vsts/work/1/s/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  {
    path: '/',
    /* internal name: '/(app)' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/(app)/(logged-in)',
          component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in).vue'),
          children: [
            _mergeRouteRecord(
              {
                path: 'admin',
                name: '/(app)/(logged-in)/admin',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/admin.vue'),
                children: [
                  _mergeRouteRecord(
                    {
                      path: 'scripts',
                      name: '/(app)/(logged-in)/admin/scripts',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/admin/scripts.vue'),
                      /* no children */
                    },
                    _definePage_default_4
                  ),
                  {
                    path: 'sentence-query-engine',
                    name: '/(app)/(logged-in)/admin/sentence-query-engine',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/admin/sentence-query-engine.vue'),
                    /* no children */
                  },
                  {
                    path: 'sentences',
                    name: '/(app)/(logged-in)/admin/sentences',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/admin/sentences.vue'),
                    /* no children */
                  }
                ],
              },
              _definePage_default_3
            ),
            _mergeRouteRecord(
              {
                path: 'calls',
                name: '/(app)/(logged-in)/calls',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/calls.vue'),
                children: [
                  _mergeRouteRecord(
                    {
                      path: 'call-history',
                      name: 'calls/call-history',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/calls/call-history.vue'),
                      /* no children */
                    },
                    _definePage_default_6
                  ),
                  _mergeRouteRecord(
                    {
                      path: 'live-call',
                      name: 'calls/live',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/calls/live-call.vue'),
                      /* no children */
                    },
                    _definePage_default_7
                  )
                ],
              },
              _definePage_default_5
            ),
            _mergeRouteRecord(
              {
                path: 'customers',
                name: '/(app)/(logged-in)/customers',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/customers.vue'),
                children: [
                  {
                    path: '',
                    name: '/(app)/(logged-in)/customers/(list)',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/customers/(list).vue'),
                    /* no children */
                  },
                  {
                    path: ':id',
                    /* internal name: '/(app)/(logged-in)/customers/[id]' */
                    /* no component */
                    children: [
                      _mergeRouteRecord(
                        {
                          path: '',
                          name: '/(app)/(logged-in)/customers/[id]/(profile)',
                          component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/customers/[id]/(profile).vue'),
                          /* no children */
                        },
                        _definePage_default_9
                      )
                    ],
                  }
                ],
              },
              _definePage_default_8
            ),
            _mergeRouteRecord(
              {
                path: 'dashboard',
                name: '/(app)/(logged-in)/dashboard',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/dashboard.vue'),
                /* no children */
              },
              _definePage_default_10
            ),
            _mergeRouteRecord(
              {
                path: 'documents',
                name: '/(app)/(logged-in)/documents',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/documents.vue'),
                /* no children */
              },
              _definePage_default_11
            ),
            _mergeRouteRecord(
              {
                path: 'feedback',
                name: 'feedback',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/feedback.vue'),
                /* no children */
              },
              _definePage_default_12
            ),
            _mergeRouteRecord(
              {
                path: 'help',
                name: '/(app)/(logged-in)/help',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/help.vue'),
                /* no children */
              },
              _definePage_default_13
            ),
            _mergeRouteRecord(
              {
                path: 'integrations',
                name: '/(app)/(logged-in)/integrations',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations.vue'),
                children: [
                  _mergeRouteRecord(
                    {
                      path: 'api-keys',
                      name: '/(app)/(logged-in)/integrations/api-keys',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/api-keys.vue'),
                      /* no children */
                    },
                    _definePage_default_15
                  ),
                  _mergeRouteRecord(
                    {
                      path: 'crm',
                      name: '/(app)/(logged-in)/integrations/crm',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/crm.vue'),
                      /* no children */
                    },
                    _definePage_default_16
                  ),
                  _mergeRouteRecord(
                    {
                      path: 'hooks',
                      name: '/(app)/(logged-in)/integrations/hooks',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/hooks.vue'),
                      /* no children */
                    },
                    _definePage_default_17
                  ),
                  {
                    path: 'products',
                    name: '/(app)/(logged-in)/integrations/products',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/products.vue'),
                    /* no children */
                  },
                  _mergeRouteRecord(
                    {
                      path: 'scripts',
                      name: '/(app)/(logged-in)/integrations/scripts',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/scripts.vue'),
                      /* no children */
                    },
                    _definePage_default_18
                  ),
                  {
                    path: 'search',
                    name: '/(app)/(logged-in)/integrations/search',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/search.vue'),
                    /* no children */
                  },
                  _mergeRouteRecord(
                    {
                      path: 'services',
                      name: '/(app)/(logged-in)/integrations/services',
                      component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/integrations/services.vue'),
                      /* no children */
                    },
                    _definePage_default_19
                  )
                ],
              },
              _definePage_default_14
            ),
            _mergeRouteRecord(
              {
                path: 'leaderboard',
                name: '/(app)/(logged-in)/leaderboard',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/leaderboard.vue'),
                /* no children */
              },
              _definePage_default_20
            ),
            {
              path: 'lessons',
              /* internal name: '/(app)/(logged-in)/lessons' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/(logged-in)/lessons/',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/lessons/index.vue'),
                    /* no children */
                  },
                  _definePage_default_21
                ),
                {
                  path: ':id',
                  name: '/(app)/(logged-in)/lessons/[id]',
                  component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/lessons/[id].vue'),
                  /* no children */
                }
              ],
            },
            {
              path: 'mockups',
              /* internal name: '/(app)/(logged-in)/mockups' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/(logged-in)/mockups/',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/index.vue'),
                    /* no children */
                  },
                  _definePage_default_22
                ),
                _mergeRouteRecord(
                  {
                    path: '_template',
                    name: '/(app)/(logged-in)/mockups/_template',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/_template.vue'),
                    /* no children */
                  },
                  _definePage_default_23
                ),
                _mergeRouteRecord(
                  {
                    path: 'rules',
                    name: '/(app)/(logged-in)/mockups/rules',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/rules.vue'),
                    /* no children */
                  },
                  _definePage_default_24
                ),
                _mergeRouteRecord(
                  {
                    path: 'scorecard-templates',
                    name: '/(app)/(logged-in)/mockups/scorecard-templates',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/mockups/scorecard-templates.vue'),
                    /* no children */
                  },
                  _definePage_default_25
                )
              ],
            },
            _mergeRouteRecord(
              {
                path: 'multiscore',
                name: '/(app)/(logged-in)/multiscore',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/multiscore.vue'),
                /* no children */
              },
              _definePage_default_26
            ),
            _mergeRouteRecord(
              {
                path: 'my-account',
                name: '/(app)/(logged-in)/my-account',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/my-account.vue'),
                /* no children */
              },
              _definePage_default_27
            ),
            _mergeRouteRecord(
              {
                path: 'rules',
                name: '/(app)/(logged-in)/rules',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/rules.vue'),
                /* no children */
              },
              _definePage_default_28
            ),
            {
              path: 'scorecard-templates',
              /* internal name: '/(app)/(logged-in)/scorecard-templates' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: 'scorecard-templates',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecard-templates/index.vue'),
                    /* no children */
                  },
                  _definePage_default_29
                ),
                {
                  path: ':id',
                  /* internal name: '/(app)/(logged-in)/scorecard-templates/[id]' */
                  /* no component */
                  children: [
                    _mergeRouteRecord(
                      {
                        path: '',
                        name: 'scorecard-template',
                        component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecard-templates/[id]/index.vue'),
                        /* no children */
                      },
                      _definePage_default_30
                    )
                  ],
                },
                _mergeRouteRecord(
                  {
                    path: 'new',
                    name: 'new-scorecard-template',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecard-templates/new.vue'),
                    /* no children */
                  },
                  _definePage_default_31
                )
              ],
            },
            {
              path: 'scorecards',
              /* internal name: '/(app)/(logged-in)/scorecards' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: 'scorecards',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecards/index.vue'),
                    /* no children */
                  },
                  _definePage_default_32
                ),
                {
                  path: ':id',
                  /* internal name: '/(app)/(logged-in)/scorecards/[id]' */
                  /* no component */
                  children: [
                    _mergeRouteRecord(
                      {
                        path: 'result',
                        name: 'scorecard-result',
                        component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecards/[id]/result.vue'),
                        /* no children */
                      },
                      _definePage_default_33
                    )
                  ],
                },
                _mergeRouteRecord(
                  {
                    path: 'scorecard',
                    name: 'new-scorecard',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scorecards/scorecard.vue'),
                    /* no children */
                  },
                  _definePage_default_34
                )
              ],
            },
            {
              path: 'scripts',
              /* internal name: '/(app)/(logged-in)/scripts' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: '',
                    name: '/(app)/(logged-in)/scripts/',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scripts/index.vue'),
                    /* no children */
                  },
                  _definePage_default_35
                ),
                {
                  path: ':id',
                  name: '/(app)/(logged-in)/scripts/[id]',
                  component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/scripts/[id].vue'),
                  /* no children */
                }
              ],
            },
            _mergeRouteRecord(
              {
                path: 'tasks',
                name: '/(app)/(logged-in)/tasks',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/tasks.vue'),
                /* no children */
              },
              _definePage_default_36
            ),
            _mergeRouteRecord(
              {
                path: 'teams',
                name: '/(app)/(logged-in)/teams',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/teams.vue'),
                children: [
                  {
                    path: ':team_id',
                    name: '/(app)/(logged-in)/teams/[team_id]',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/teams/[team_id].vue'),
                    children: [
                      {
                        path: '',
                        name: '/(app)/(logged-in)/teams/[team_id]/(users)',
                        component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/teams/[team_id]/(users).vue'),
                        /* no children */
                      },
                      {
                        path: 'settings',
                        name: '/(app)/(logged-in)/teams/[team_id]/settings',
                        component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/teams/[team_id]/settings.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'all',
                    name: '/(app)/(logged-in)/teams/all',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/teams/all.vue'),
                    /* no children */
                  },
                  {
                    path: 'list',
                    name: '/(app)/(logged-in)/teams/list',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/teams/list.vue'),
                    /* no children */
                  }
                ],
              },
              _definePage_default_37
            ),
            _mergeRouteRecord(
              {
                path: 'training',
                name: '/(app)/(logged-in)/training',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/training.vue'),
                /* no children */
              },
              _definePage_default_38
            ),
            _mergeRouteRecord(
              {
                path: 'users',
                name: '/(app)/(logged-in)/users',
                component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/users.vue'),
                children: [
                  {
                    path: ':user_id',
                    name: '/(app)/(logged-in)/users/[user_id]',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/users/[user_id].vue'),
                    /* no children */
                  },
                  {
                    path: 'list',
                    name: '/(app)/(logged-in)/users/list',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-in)/users/list.vue'),
                    /* no children */
                  }
                ],
              },
              _definePage_default_39
            )
          ],
        },
        _definePage_default_2
      ),
      _mergeRouteRecord(
        {
          path: '',
          name: '/(app)/(logged-out)',
          component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-out).vue'),
          children: [
            {
              path: 'auth',
              /* internal name: '/(app)/(logged-out)/auth' */
              /* no component */
              children: [
                _mergeRouteRecord(
                  {
                    path: 'callback',
                    name: 'auth-callback',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-out)/auth/callback.vue'),
                    /* no children */
                  },
                  _definePage_default_41
                ),
                {
                  path: 'login',
                  name: '/(app)/(logged-out)/auth/login',
                  component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-out)/auth/login.vue'),
                  /* no children */
                },
                _mergeRouteRecord(
                  {
                    path: 'logout',
                    name: '/(app)/(logged-out)/auth/logout',
                    component: () => import('/home/vsts/work/1/s/src/pages/(app)/(logged-out)/auth/logout.vue'),
                    /* no children */
                  },
                  _definePage_default_42
                )
              ],
            }
          ],
        },
        _definePage_default_40
      )
    ],
  },
  {
    path: '/:404(.*)',
    name: '/[...404]',
    component: () => import('/home/vsts/work/1/s/src/pages/[...404].vue'),
    /* no children */
  },
  _mergeRouteRecord(
    {
      path: '/select',
      name: '/select',
      component: () => import('/home/vsts/work/1/s/src/pages/select.vue'),
      /* no children */
    },
    _definePage_default_43
  )
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

